// language-popup.js - Clean version

// Language translations for all UI text
const TRANSLATIONS = {
  // 英语 - 默认
  'en': {
    title: 'Select your region',
    subtitle: 'Choose your preferred language and currency',
    language: 'Language',
    currency: 'Currency',
    apply: 'Apply Settings',
    continue: 'Continue in English',
    loading: 'Loading...'
  },
  
  // 简体中文
  'zh': {
    title: '选择您的地区',
    subtitle: '选择您偏好的语言和货币',
    language: '语言',
    currency: '货币',
    apply: '应用设置',
    continue: '继续浏览英文版',
    loading: '加载中...'
  },
  
  // 法语
  'fr': {
    title: 'Sélectionnez votre région',
    subtitle: 'Choisissez votre langue et devise préférées',
    language: 'Langue',
    currency: 'Devise',
    apply: 'Appliquer',
    continue: 'Continuer en anglais',
    loading: 'Chargement...'
  },
  
  // 德语
  'de': {
    title: 'Wählen Sie Ihre Region',
    subtitle: 'Wählen Sie Ihre bevorzugte Sprache und Währung',
    language: 'Sprache',
    currency: 'Währung',
    apply: 'Übernehmen',
    continue: 'Auf Englisch fortfahren',
    loading: 'Laden...'
  },
  
  // 意大利语
  'it': {
    title: 'Seleziona la tua regione',
    subtitle: 'Scegli la tua lingua e valuta preferite',
    language: 'Lingua',
    currency: 'Valuta',
    apply: 'Applica impostazioni',
    continue: 'Continua in inglese',
    loading: 'Caricamento...'
  },
  
  // 日语
  'ja': {
    title: '地域を選択してください',
    subtitle: '希望の言語と通貨をお選びください',
    language: '言語',
    currency: '通貨',
    apply: '設定を適用',
    continue: '英語版を続ける',
    loading: '読み込み中...'
  },
  
  // 西班牙语
  'es': {
    title: 'Selecciona tu región',
    subtitle: 'Elige tu idioma y moneda preferidos',
    language: 'Idioma',
    currency: 'Moneda',
    apply: 'Aplicar Cambios',
    continue: 'Continuar en Inglés',
    loading: 'Cargando...'
  },
  
  // 阿拉伯语
  'ar': {
    title: 'اختر منطقتك',
    subtitle: 'اختر لغتك وعملتك المفضلة',
    language: 'اللغة',
    currency: 'العملة',
    apply: 'تطبيق الإعدادات',
    continue: 'المتابعة بالإنجليزية',
    loading: 'جاري التحميل...'
  }
};

// Language-Country mapping - 简化，只保留需要的字段
const LANGUAGE_COUNTRY_MAP = {
  // Spanish speaking
  'ES': { language: 'es' },
  'MX': { language: 'es' },
  'AR': { language: 'es' },
  'CO': { language: 'es' },
  'CL': { language: 'es' },
  'PE': { language: 'es' },
  
  // Arabic speaking
  'SA': { language: 'ar' },
  'AE': { language: 'ar' },
  'EG': { language: 'ar' },
  'KW': { language: 'ar' },
  'QA': { language: 'ar' },
  
  // English speaking
  'US': { language: 'en' },
  'GB': { language: 'en' },
  'CA': { language: 'en' },
  'AU': { language: 'en' },
  
  // French speaking
  'FR': { language: 'fr' },
  
  // German speaking
  'DE': { language: 'de' },
  'AT': { language: 'de' },
  'CH': { language: 'de' },

  // Italian speaking
  'IT': { language: 'it' },
  
  // Japanese speaking
  'JP': { language: 'ja' },

  // Chinese speaking
  'CN': { language: 'zh' }
};

// Function to get user's language based on IP
async function detectUserLanguage() {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    
    return {
      countryCode: data.country_code,
      languageCode: getLanguageFromCountry(data.country_code),
    };
  } catch (error) {
    console.log('IP detection failed, using browser language as fallback');
    return detectFromBrowser();
  }
}

// Fallback: detect from browser settings
function detectFromBrowser() {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0];
  
  // Map browser language to a default country
  const langToCountry = {
    'en': 'US',
    'zh': 'CN',
    'fr': 'FR',
    'de': 'DE',
    'it': 'IT',
    'ja': 'JP',
    'es': 'ES',
    'ar': 'SA'
  };
  
  return {
    countryCode: langToCountry[langCode] || 'US',
    fromBrowser: true,
    languageCode: langCode
  };
}

// Get language code from country code
function getLanguageFromCountry(countryCode) {
  const country = LANGUAGE_COUNTRY_MAP[countryCode];
  return country ? country.language : 'en';
}

// Update UI text based on language
function updateUIText(languageCode) {
  const translations = TRANSLATIONS[languageCode] || TRANSLATIONS['en'];
  
  const titleEl = document.getElementById('popup-title');
  const subtitleEl = document.getElementById('popup-subtitle');
  const languageLabel = document.querySelector('.selector-group:first-child label');
  const currencyLabel = document.querySelector('.selector-group:last-child label');
  const applyBtn = document.querySelector('.btn-primary');
  const continueBtn = document.querySelector('.btn-secondary');
  
  if (titleEl) titleEl.textContent = translations.title;
  if (subtitleEl) subtitleEl.textContent = translations.subtitle;
  if (languageLabel) languageLabel.textContent = translations.language;
  if (currencyLabel) currencyLabel.textContent = translations.currency;
  if (applyBtn) applyBtn.textContent = translations.apply;
  if (continueBtn) continueBtn.textContent = translations.continue;
  
  // RTL for Arabic
  const popupContent = document.querySelector('.popup-content');
  if (popupContent) {
    if (languageCode === 'ar') {
      popupContent.style.direction = 'rtl';
      document.querySelector('.popup-close').style.right = 'auto';
      document.querySelector('.popup-close').style.left = '15px';
    } else {
      popupContent.style.direction = 'ltr';
      document.querySelector('.popup-close').style.left = 'auto';
      document.querySelector('.popup-close').style.right = '15px';
    }
  }
}

// Check if popup should be shown
function shouldShowPopup(userInfo) {
  // Check if user has already made a choice
  const preference = localStorage.getItem('languagePreference');
  if (preference) {
    const pref = JSON.parse(preference);
    const oneWeek = 7 * 24 * 60 * 60 * 1000;
    if (Date.now() - new Date(pref.timestamp) < oneWeek) {
      return false;
    }
  }
  
  // Don't show on Google Shopping clicks
  const referrer = document.referrer;
  if (referrer.includes('google.com/shopping') || 
      referrer.includes('googleads') ||
      referrer.includes('shopping.google') ||
      referrer.includes('google.com/ads') ||
      referrer.includes('googleadservices.com')) {
    return false;
  }
  
  // Don't show for English-speaking countries
  const englishSpeakingCountries = ['US', 'GB', 'CA', 'AU', 'NZ', 'IE'];
  if (userInfo && englishSpeakingCountries.includes(userInfo.countryCode)) {
    return false;
  }
  
  return true;
}

// Handle language change
function handleLanguageChange(select) {
  const selectedLang = select.value;
  updateUIText(selectedLang);
}

// Handle currency change
function handleCurrencyChange(select) {
  // Optional: Add currency change logic if needed
}

// Apply changes and redirect
async function applyChanges() {
  const language = document.getElementById('language-select').value;
  const currency = document.getElementById('currency-select').value;
  
  // Save preference
  localStorage.setItem('languagePreference', JSON.stringify({
    language: language,
    currency: currency,
    timestamp: new Date().toISOString()
  }));
  
  // Show loading state
  const applyBtn = document.querySelector('.btn-primary');
  const translations = TRANSLATIONS[language] || TRANSLATIONS['en'];
  applyBtn.textContent = translations.loading;
  applyBtn.disabled = true;
  
  // Construct new URL
  const currentUrl = new URL(window.location.href);
  const pathParts = currentUrl.pathname.split('/');
  
  // Update language in URL
  if (language !== 'en') {
    if (pathParts[1] !== language) {
      pathParts[1] = language;
    }
  } else {
    // Remove language code for English (default)
    if (pathParts[1]?.length === 2) {
      pathParts.splice(1, 1);
    }
  }
  
  currentUrl.pathname = pathParts.join('/');
  currentUrl.searchParams.set('currency', currency);
  
  // Redirect
  window.location.href = currentUrl.toString();
}

// Close popup
function closeLanguagePopup() {
  localStorage.setItem('languagePreference', JSON.stringify({
    dismissed: true,
    timestamp: new Date().toISOString()
  }));
  
  const popup = document.getElementById('language-popup');
  if (popup) {
    popup.style.display = 'none';
  }
}

// Initialize popup
async function initLanguagePopup() {
  const popup = document.getElementById('language-popup');
  if (!popup) return;
  
  // Detect user's location
  const userInfo = await detectUserLanguage();
  
  // Check if popup should be shown
  if (!shouldShowPopup(userInfo)) {
    return;
  }
  
  // Check if current page already has a language in URL
  const currentPath = window.location.pathname;
  const currentLang = currentPath.split('/')[1];
  
  // Don't show if URL already has a non-English language
  if (currentLang && currentLang !== 'en' && currentLang.length === 2) {
    return;
  }
  
  // Update popup text based on user's region
  const displayLang = userInfo.languageCode || 'en';
  updateUIText(displayLang);
  
  // Show popup after delay
  setTimeout(() => {
    popup.style.display = 'block';
    
    // Add ESC key handler
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeLanguagePopup();
      }
    });
  }, 1000);
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initLanguagePopup);